import { Nullable } from 'common-types';
import {
  ERelevance,
  IrrelevantApp,
  RawIrrelevantApp,
} from '../irrelevant-apps-types';
import IrrelevantAppsStore from '../stores/irrelevant-apps-store';

export const setIrrelevantApps = (apps: RawIrrelevantApp[]) => {
  IrrelevantAppsStore.apps = apps;
};

export const setIrrelevantAppsError = (
  isError: boolean,
  errorMessage: Nullable<string>,
) => {
  IrrelevantAppsStore.generalError = isError;
  IrrelevantAppsStore.errorMessage = errorMessage;
};

export const setIsLoadingIrrelevantApps = (isLoading: boolean): void => {
  IrrelevantAppsStore.isLoading = isLoading;
};

export const setRelevetAppModal = (relevntModal: boolean): void => {
  IrrelevantAppsStore.relevntModal = relevntModal;
};

export const setSelectedReleventApp = (app: IrrelevantApp | null): void => {
  IrrelevantAppsStore.selectedReleventApp = app;
};

export const setShowMakeRelevantDialog = (isLoading: boolean): void => {
  IrrelevantAppsStore.showMakeRelevantDialog = isLoading;
};

export const setIsRemoveIrrelevantAppLoading = (isLoading: boolean): void => {
  IrrelevantAppsStore.isRemoveIrrelevantAppLoading = isLoading;
};

export const setReleventAppType = (releventType: ERelevance) => {
  IrrelevantAppsStore.releventType = releventType;
};
